const Auxx = props => props.children;

export default Auxx;



// WEBPACK FOOTER //
// ./src/HOCs/AUXX/Auxx.js